//ニュース＆トピックス一覧の文字数調整
$("#news-amp-topics .b-article h2").each(function(){
  var size = 28;
  var txt = $(this).text();
  var suffix = '…';
  var b = 0;
  for(var i = 0; i < txt.length; i++) {
    b += txt.charCodeAt(i) <= 255 ? 0.5 : 1;
    if (b > size) {
      txt = txt.substr(0, i) + suffix;
      break;
    }
  }
  $(this).text(txt);
});

$("#news-amp-topics .b-excerpt").each(function(){
  var size = 30;
  var txt = $(this).text();
  var suffix = '…';
  var b = 0;
  for(var i = 0; i < txt.length; i++) {
    b += txt.charCodeAt(i) <= 255 ? 0.5 : 1;
    if (b > size) {
      txt = txt.substr(0, i) + suffix;
      break;
    }
  }
  $(this).text(txt);
});

//blogのproducts一覧の文字数調整
$("#products.template-blog .b-excerpt").each(function(){
  var size = 30;
  var txt = $(this).text();
  var suffix = '…';
  var b = 0;
  for(var i = 0; i < txt.length; i++) {
    b += txt.charCodeAt(i) <= 255 ? 0.5 : 1;
    if (b > size) {
      txt = txt.substr(0, i) + suffix;
      break;
    }
  }
  $(this).text(txt);
});


//スムーススクロール
$(function(){
	$('a[href^="#"]').click(function(){
		var speed = 500;
		var href= $(this).attr("href");
		var target = $(href == "#" || href == "" ? 'html' : href);
		var position = target.offset().top;
		$("html, body").animate({scrollTop:position}, speed, "swing");
		return false;
	});
});

//商品詳細画像
$('.product__image_slide').slick({
    dots: true,
    arrows: true,
  	prevArrow: '<a class="slick-prev" href="#"><img src="https://cdn.shopify.com/s/files/1/0496/5515/2795/files/product_arrow_prev.png" alt="Prev" /></a>',
    nextArrow: '<a class="slick-next" href="#"><img src="https://cdn.shopify.com/s/files/1/0496/5515/2795/files/product_arrow_next.png" alt="Next" /></a>',
    customPaging: function(slick,index) {
        // スライダーのインデックス番号に対応した画像のsrcを取得
        var targetImage = slick.$slides.eq(index).find('img').attr('src');
        // slick-dots > li　の中に上記で取得した画像を設定
        return '<img src=" ' + targetImage + ' "/>';
    },
    responsive: [{
      breakpoint: 749,
      settings: {
        arrows: false,
      }
    }]
});

//LightBox
$(function(){
  var luminousTrigger = document.querySelectorAll('.luminous');
  if( luminousTrigger !== null ) {
    new LuminousGallery(luminousTrigger);
  }
});

//ヘッダーのスクロール表示制御
$(function(){
  var wrapper = document.querySelector('.site-header-wrapper');
  var header = document.querySelector('.site-header-container');
  var announcementBar = document.querySelector('.announcement-bar');

  if (!wrapper || !header) {
    return;
  }

  var lastScrollY = Math.max(window.pageYOffset || document.documentElement.scrollTop, 0);
  var headerHeight = 0;
  var announcementHeight = 0;
  var scrollThreshold = 8;
  var ticking = false;
  var requestFrame = window.requestAnimationFrame || function(callback) {
    return setTimeout(callback, 16);
  };

  function getScrollY() {
    return Math.max(window.pageYOffset || document.documentElement.scrollTop, 0);
  }

  function getAnnouncementHeight() {
    if (!announcementBar) {
      return 0;
    }

    var style = window.getComputedStyle ? window.getComputedStyle(announcementBar) : null;

    if (style && style.display === 'none') {
      return 0;
    }

    return announcementBar.offsetHeight || 0;
  }

  function updateHeaderOffset(scrollY) {
    var offsetTop = Math.max(announcementHeight - scrollY, 0);
    header.style.setProperty('--site-header-offset-top', offsetTop + 'px');
  }

  function setHeaderMeasurements() {
    headerHeight = header.offsetHeight || 0;
    announcementHeight = getAnnouncementHeight();
    wrapper.style.height = headerHeight + 'px';
    updateHeaderOffset(getScrollY());
  }

  function isDrawerOpen() {
    return document.documentElement.classList.contains('js-drawer-open') ||
      document.body.classList.contains('js-drawer-open');
  }

  function showHeader(currentScrollY) {
    header.classList.remove('site-header-container--hidden');
    lastScrollY = currentScrollY;
    ticking = false;
  }

  function updateHeader() {
    var currentScrollY = getScrollY();
    var scrollDelta = currentScrollY - lastScrollY;

    updateHeaderOffset(currentScrollY);

    if (isDrawerOpen() || currentScrollY <= headerHeight + announcementHeight) {
      showHeader(currentScrollY);
      return;
    }

    if (Math.abs(scrollDelta) < scrollThreshold) {
      ticking = false;
      return;
    }

    if (scrollDelta > 0) {
      header.classList.add('site-header-container--hidden');
    } else {
      header.classList.remove('site-header-container--hidden');
    }

    lastScrollY = currentScrollY;
    ticking = false;
  }

  function requestTick() {
    if (ticking) {
      return;
    }

    ticking = true;
    requestFrame(updateHeader);
  }

  setHeaderMeasurements();

  window.addEventListener('scroll', requestTick, { passive: true });
  window.addEventListener('resize', function() {
    setHeaderMeasurements();
    requestTick();
  });
  window.addEventListener('load', setHeaderMeasurements);
});

//トップページのスクロールバー補助
$(window).load(function(){
    var $actionBarMain = $('.action-bar__menu--main');
    var actionBarOffset = $actionBarMain.offset();

    if (!$actionBarMain.length || !actionBarOffset) {
      return;
    }

    var idx_height_top = actionBarOffset.top;
    var idx_height = $('#PageContainer').outerHeight();
  
	$(window).scroll(function(){
  		var scroll = $(window).scrollTop();
  		if ( scroll > idx_height ) {
    		$('.template-index').addClass('js-sticky-action-bar');
    		setTimeout(function(){
      		$('.template-index').addClass('js-sticky-action-bar--open');
              },300);
        } else if( scroll < idx_height_top ) {
    		$('.template-index').removeClass('js-sticky-action-bar js-sticky-action-bar--open');
  		}
	});
});
